import { StoreCacheError } from "./StoreCacheError";

export class GenerationFailureError extends StoreCacheError {
    constructor(innerError: unknown) {
        const innerName =
            typeof innerError === "object" &&
            innerError !== null &&
            "name" in innerError
                ? innerError.name
                : undefined;

        const innerMessage =
            typeof innerError === "object" &&
            innerError !== null &&
            "message" in innerError
                ? innerError.message
                : typeof innerError === "string"
                  ? innerError
                  : undefined;

        const message = ["GenerationFailureError", innerName, innerMessage]
            .filter(it => !!it)
            .join(": ");

        super(message);
        this.name = "GenerationFailureError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
